enum TabDepartment {
    USER = "1",
    FOLIO = "2",
    DEPARTMENT = "3",
}

enum Recive {
    STORE = 'store',
    USER = 'user',
    USER_TYPE = 'userType'
}
export { TabDepartment, Recive }